<template>
  <div>
    <span class="d-inline-block">
      <paginate
          :class="paginateClass"
          :click-handler="navigateHandler"
          :margin-pages="marginPages"
          :next-text="nextText"
          :page-count="pageCount"
          :page-range="pageRange"
          :prev-text="prevText"
          container-class="pagination"
          next-class="page-item"
          next-link-class="page-link"
          page-class="page-item"
          page-link-class="page-link"
          prev-class="page-item"
          prev-link-class="page-link"
          v-model="currentPageIn">
      </paginate>
    </span>
    <div class="ml-2 d-inline" v-if="customPage">
      <span>
          <input
              :class="userCustomPageClass"
              class="form-control d-inline-block"
              style="width: 50px;text-align: center"
              type="text"
              v-model="userCustomPage"/>
      </span>
      <span class="ml-2" style="position: relative;top: -2px">
        <button @click="goToUserCustomPage" class="btn border-secondary" type="button">Go</button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      required: true
    },
    customPage: {
      required: false,
      default: true
    },
    navigateHandler: {
      required: true
    },
    pageCount: {
      required: true
    },
    pageRange: {
      required: false,
      default: 4
    },
    marginPages: {
      required: false,
      default: 2
    },
    prevText: {
      required: false,
      default: 'Prev'
    },
    nextText: {
      required: false,
      default: 'Next'
    },
    paginateClass: {
      required: false,
      default: 'mt-2'
    }
  },
  data() {
    return {
      userCustomPage: null,
      userCustomPageClass: '',
      currentPageIn: 1
    }
  },
  beforeMount() {
    this.currentPageIn = this.currentPage
  },
  methods: {
    goToUserCustomPage() {
      let p = this.userCustomPage
      if (isNaN(p) || !p || p > this.pageCount) {
        this.userCustomPageClass = 'border-danger'
      } else {
        this.userCustomPageClass = ''
        this.navigateHandler(p)
      }
    }
  }
}
</script>

<style>
.pagination {
  font-size: 11px;
}
</style>
